<template>
  <div class="ui form">
    <div class="required field" >
      <label for="doctor">Doctor</label>
      <select
        class="ui fluid search dropdown"
        :class="{disabled: !isCurrentShiftStarting}"
        id="doctor-search"
        v-model="shift.doctor_id"
        name="clinic"
        v-if="isCurrentShiftStarting"
      >
        <option value="">Choose doctor</option>
        <option :value="doctor.id" v-for="doctor in doctorsMeta" :key="doctor.id">
          {{ doctor.user.name }}
        </option>
      </select>
      <div v-else> 
        {{ getDoctorName(currentShift.doctor_id) }}
      </div>
    </div>
    <h4 class="ui horizontal divider header">
      Medical machines readings
    </h4>

    <table class="ui definition center aligned celled compact table" style="margin-top: 30px">
      <thead>
        <tr>
          <th style="width: 25%"></th>
          <th>First Reading</th>
          <th v-if="!isCurrentShiftStarting">Last Reading</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="medicalMachine in shift.medical_machines" :key="medicalMachine.id">
          <td>{{ medicalMachine.name }}</td>
          <td v-if="isCurrentShiftStarting">
            <div class="ui fluid input">
              <input 
                type="number" 
                v-model="medicalMachine.start_reading" 
                style="text-align:center"
                placeholder="First Reading"
              />
            </div>
          </td>
          <td v-if="!isCurrentShiftStarting">
            {{ medicalMachine.start_reading }}
          </td>
          <td v-if="!isCurrentShiftStarting">
            <div class="ui fluid input">
              <input 
                type="number" 
                v-model="medicalMachine.end_reading" 
                style="text-align:center"
                placeholder="Last Reading"
              />
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <div v-if="beforeCurrentShift && beforeCurrentShift.finished_at">
      <h4 class="ui horizontal divider header">
        last shift readings
      </h4>
      <table class="ui definition center aligned celled compact table" style="margin-top: 30px">
        <thead>
          <tr>
            <th style="width: 25%"></th>
            <th>Last Reading</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="medicalMachine in formatCompleteShift()" :key="medicalMachine.id">
            <td>{{ medicalMachine.name }}</td>
            <td>{{ medicalMachine.end_reading }}</td>
          </tr>
        </tbody>
      </table>

    </div>

    <div class="ui blue right floated submit button no-print"
      style="background-color: #092442;"
      @click="submit()">
      {{ submitButtonName }}
    </div>

    <div class="ui negative message"  style="margin-top: 60px" v-if="showError">
      {{ error }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    medicalMachines: { type: Array, required: true },
    currentShift: { type: Object, default: () => {} },
    beforeCurrentShift: { type: Object, default: () => {} },
    roomId: { type: Number, required: true }
  },
  data() {
    return {
      shift: {
        doctor_id: null,
        medical_machines: []
      },
      error: '',
      showError: false
    }
  },
  mounted () {
    this.fromatShiftMedicalMachines();
    this.initGui()
    this.loading = false
  },
  computed: {
    submitButtonName() {
      return this.isCurrentShiftStarting ? 'Start shift' : 'End shift'
    },
    isCurrentShiftStarting() {
      return !this.currentShift || !this.currentShift.started_at
    } 
  },
  methods: {
    fromatShiftMedicalMachines() {
      let readingsByMedicalMachineId = null
      if (!this.isCurrentShiftStarting) {
        let startReadings = this.currentShift.medical_machine_readings.filter(mmr => mmr.reading_type_id === 1)
        readingsByMedicalMachineId = 
          startReadings.reduce((obj, r) => ({...obj, [r.medical_machine.id]: r}), {})
      }
      this.shift.medical_machines = this.medicalMachines.map(medicalMachine => ({
        id: medicalMachine.id,
        name: medicalMachine.name, 
        start_reading : readingsByMedicalMachineId ?
          readingsByMedicalMachineId[medicalMachine.id].reading : null,
        end_reading: null
      }))
    },
    initGui() {
      this.$nextTick(() => {
        $('#doctor-search').dropdown()
      })
    },
    submit() {
      this.isCurrentShiftStarting ?
        this.startShift() : this.endShift()
    },
    startShift() {
      let isDataValid = this.shift.medical_machines.filter(mm => Number(mm.start_reading) >= 0 ) &&
        this.shift.doctor_id
      if (isDataValid) {
        this.showError = false
        this.$http.post(`rooms/${this.roomId}/shifts/start`, {
          clinic_id: this.getClinicId(),
          shift: this.shift
        }).then(response => {
          this.$emit('shift-started')
        }).catch(error => {
          console.log(error)
          this.error = 'Your current readings doesn\'t equal last shift reading. Please, Make sure you entered the right reading'
          this.showError = true
        });
      } else {
        
      }
    },
    endShift() {
      let isDataValid = this.shift.medical_machines.filter(mm => Number(mm.end_reading) >= 0 )

      if(isDataValid) {
        this.showError = false
        this.$http.post(`rooms/${this.roomId}/shifts/${this.currentShift.id}/end`, {
          clinic_id: this.getClinicId(),
          shift: this.shift
        }).then(response => {
          this.$emit('shift-ended')
        }).catch(error => {
          console.log(error);
          this.error = 'There are an error with pulses calculations'
          this.showError = true
        });
      } else {

      }

    },
    getDoctorName (doctorId) {
      return this.doctorsMeta.find(doctorId).user.name
    },
    formatCompleteShift() {
      let startReadingsByMedicalMachineId = null
      let endReadingsByMedicalMachineId = null
      let endReadings = this.beforeCurrentShift.medical_machine_readings.filter(mmr => mmr.reading_type_id === 2)
      let startReadings = this.beforeCurrentShift.medical_machine_readings.filter(mmr => mmr.reading_type_id === 1)
      startReadingsByMedicalMachineId = 
        startReadings.reduce((obj, r) => ({...obj, [r.medical_machine.id]: r}), {})
      endReadingsByMedicalMachineId = 
        endReadings.reduce((obj, r) => ({...obj, [r.medical_machine.id]: r}), {})
      return this.medicalMachines.map(medicalMachine => ({
        id: medicalMachine.id,
        name: medicalMachine.name, 
        start_reading : startReadingsByMedicalMachineId ?
          startReadingsByMedicalMachineId[medicalMachine.id].reading : null,
        end_reading: endReadingsByMedicalMachineId ?
          endReadingsByMedicalMachineId[medicalMachine.id].reading : null
      }))
    }
  },
}
</script>

<style scoped>
  .centered-header {
    display: flex;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/rooms/room_components/shifts_component/CurrentShift.vue